<app-side-menu>
  <div class="third-party-os-page">
    <div class="page-header d-flex align-items-center justify-content-between flex-wrap gap-2">
      <div>
        <h1 class="page-title mb-1">
          <i class="fas fa-file-invoice me-2"></i>
          Gerar OS de Terceiros
        </h1>
        <p class="text-muted mb-0">
          Agendamento <span *ngIf="appointmentId">#{{ appointmentId }}</span> — preencha as informações para
          abrir a Ordem de Serviço.
        </p>
      </div>
      <button type="button" class="btn btn-outline-secondary" (click)="cancel()" [disabled]="submitting">
        <i class="fas fa-arrow-left me-1"></i>
        Voltar
      </button>
    </div>

    <app-loading [show]="isLoading" [overlay]="false" message="Carregando informações..."></app-loading>

    <div *ngIf="!isLoading && error" class="alert alert-danger m-4">
      <i class="fas fa-exclamation-triangle me-2"></i>
      {{ error }}
    </div>

  <form *ngIf="!isLoading && !error && appointment" [formGroup]="form" (ngSubmit)="submit()" class="mt-3">

    <!-- Resumo do agendamento -->
    <div class="card section-card mb-3">
      <div class="card-header">
        <h5 class="mb-0"><i class="fas fa-calendar-alt me-2"></i>Resumo do Agendamento</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label text-muted small mb-1">Data</label>
            <div class="fw-semibold">{{ appointment.Date | date: 'dd/MM/yyyy' }}</div>
          </div>
          <div class="col-md-3">
            <label class="form-label text-muted small mb-1">Horário</label>
            <div class="fw-semibold">
              {{ (appointment.StartTime || '').substring(0, 5) }} -
              {{ (appointment.EndTime || '').substring(0, 5) }}
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label text-muted small mb-1">Status</label>
            <div><span class="badge bg-warning">{{ appointment.Status }}</span></div>
          </div>
          <div class="col-md-3">
            <label class="form-label text-muted small mb-1">Assunto</label>
            <div class="fw-semibold">{{ appointment.Subject || '-' }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Cliente -->
    <div class="card section-card mb-3">
      <div class="card-header">
        <h5 class="mb-0"><i class="fas fa-user me-2"></i>Cliente</h5>
      </div>
      <div class="card-body">
        <div *ngIf="customer; else noCustomer" class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Nome</label>
            <input type="text" class="form-control" [value]="customer.name" readonly>
          </div>
          <div class="col-md-3">
            <label class="form-label">CPF/CNPJ</label>
            <input type="text" class="form-control" [value]="customer.documentNumber || ''" readonly>
          </div>
          <div class="col-md-3">
            <label class="form-label">Telefone</label>
            <input type="text" class="form-control" [value]="customer.primaryPhone || ''" readonly>
          </div>
        </div>
        <ng-template #noCustomer>
          <div class="alert alert-warning mb-0">
            <i class="fas fa-exclamation-triangle me-2"></i>
            Nenhum cliente vinculado a este agendamento.
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Dados da OS -->
    <div class="card section-card mb-3">
      <div class="card-header">
        <h5 class="mb-0"><i class="fas fa-clipboard-list me-2"></i>Dados da OS</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <label for="configOrderId" class="form-label">
              Tipo de OS (Terceiros) <span class="text-danger">*</span>
            </label>
            <select id="configOrderId" class="form-select"
              formControlName="configOrderId"
              (change)="onConfigOrderChange()">
              <option [ngValue]="null" disabled>Selecione...</option>
              <option *ngFor="let cfg of thirdPartyConfigs" [ngValue]="cfg.id">
                {{ cfg.typeOS }}
              </option>
            </select>
            <div *ngIf="!thirdPartyConfigs.length" class="text-muted small mt-1">
              <i class="fas fa-info-circle me-1"></i>
              Nenhuma configuração de OS de terceiros cadastrada.
            </div>
            <div class="invalid-tip text-danger small mt-1"
              *ngIf="form.get('configOrderId')?.touched && form.get('configOrderId')?.invalid">
              Selecione o tipo de OS.
            </div>
          </div>

          <div class="col-md-6">
            <label for="openingDate" class="form-label">
              Data e Hora de Abertura <span class="text-danger">*</span>
            </label>
            <input id="openingDate" type="datetime-local" class="form-control"
              formControlName="openingDate">
            <div class="invalid-tip text-danger small mt-1"
              *ngIf="form.get('openingDate')?.touched && form.get('openingDate')?.invalid">
              Informe a data e hora de abertura.
            </div>
          </div>

          <div class="col-md-12">
            <label for="motivoAbertura" class="form-label">
              Descrição / Motivo de Abertura <span class="text-danger">*</span>
            </label>
            <textarea id="motivoAbertura" class="form-control" rows="3"
              formControlName="motivoAbertura"
              placeholder="Descreva o motivo da abertura desta OS"></textarea>
            <div class="invalid-tip text-danger small mt-1"
              *ngIf="form.get('motivoAbertura')?.touched && form.get('motivoAbertura')?.invalid">
              Informe a descrição da OS.
            </div>
          </div>

          <div class="col-md-12">
            <label for="veiculoPlaca" class="form-label">Veículo (opcional)</label>
            <div class="input-group">
              <input id="veiculoPlaca" type="text" class="form-control"
                formControlName="veiculoPlaca"
                placeholder="Nenhum veículo selecionado"
                readonly>
              <button type="button" class="btn btn-outline-primary" (click)="openVehicleModal()"
                title="Pesquisar veículo por placa">
                <i class="fas fa-search me-1"></i>
                Pesquisar Placa
              </button>
              <button type="button" class="btn btn-outline-danger" *ngIf="selectedVehicle"
                (click)="clearVehicle()" title="Remover veículo">
                <i class="fas fa-times"></i>
              </button>
            </div>
            <small class="form-text text-muted">
              Vincule um veículo à OS pesquisando pela placa.
            </small>
          </div>

          <div class="col-md-12">
            <label for="observacoes" class="form-label">Observações</label>
            <textarea id="observacoes" class="form-control" rows="2"
              formControlName="observacoes"
              placeholder="Informações adicionais (opcional)"></textarea>
          </div>
        </div>

        <div class="alert alert-info mt-3 mb-0">
          <i class="fas fa-info-circle me-2"></i>
          A OS será criada vinculada ao cliente do agendamento. Você poderá complementá-la posteriormente
          em <strong>Ordens de Serviço</strong>.
        </div>
      </div>
    </div>

    <!-- Ações -->
    <div class="d-flex justify-content-end gap-2 mt-3 mb-5">
      <button type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="submitting">
        <i class="fas fa-times me-1"></i>
        Cancelar
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="submitting || form.invalid">
        <i class="fas fa-spinner fa-spin me-1" *ngIf="submitting"></i>
        <i class="fas fa-check me-1" *ngIf="!submitting"></i>
        {{ submitting ? 'Criando OS...' : 'Criar OS' }}
      </button>
    </div>
  </form>

  <app-vehicle-selection-modal
    #vehicleModal
    (vehicleSelected)="onVehicleSelected($event)">
  </app-vehicle-selection-modal>
  </div>
</app-side-menu>
